// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#modal-add-product .modal-footer[data-v-8ab5ae84]{display:block;padding:.5rem}", "",{"version":3,"sources":["webpack://./resources/js/backup/RequestProductModal.vue"],"names":[],"mappings":"AAAA,kDAAiC,aAAa,CAAC,aAAa","sourcesContent":["#modal-add-product .modal-footer{display:block;padding:.5rem}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
